import { useQuery } from 'react-query';
import { fetchAccounts } from './fetch-accounts';

const useAccounts = (budgetId, options) => {
  const queryKey = ['ACCOUNTS', { budgetId }];
  return useQuery(queryKey, () => fetchAccounts(budgetId), options);
};

export { useAccounts };
